import { useEffect } from 'react';

export function useScrollAnimation(): void {
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                for (const entry of entries) {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('is-visible');
                    }
                }
            },
            { threshold: 0.15 },
        );

        // Observe existing elements
        const elements = document.querySelectorAll('.animate-on-scroll');
        for (const el of elements) {
            observer.observe(el);
        }

        // Watch for dynamically added elements
        const mutation = new MutationObserver((mutations) => {
            for (const m of mutations) {
                for (const node of m.addedNodes) {
                    if (!(node instanceof HTMLElement)) continue;
                    if (node.classList.contains('animate-on-scroll')) {
                        observer.observe(node);
                    }
                    for (const child of node.querySelectorAll('.animate-on-scroll')) {
                        observer.observe(child);
                    }
                }
            }
        });

        mutation.observe(document.body, { childList: true, subtree: true });

        return () => {
            observer.disconnect();
            mutation.disconnect();
        };
    }, []);
}
